import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { useUserStore } from "../../../store/userStore.js";


import EditProfileBoxLabel from "../../../components/label/editprofileboxlabel";
import PrimaryButton from "../../../components/button/primarybutton";
import ApprovedButton from "../../../components/button/approvedbutton";
import PendingButton from "../../../components/button/pendingbutton";
import RejectedButton from "../../../components/button/rejectedbutton";

import Spacer from "../../../components/spacer/spacer";
import Loader from "../../../components/loader/loader";

import images from "../../../assets";

import TabHeading from "./tabheading";
import "./styles.css";
const { TextArea } = Input;

const Description = () => {
  const { user, isUserLoading, getUser, updateUser } = useUserStore();

  const [idealMatchDescription, setIdealMatchDescription] = useState("");

  useEffect(() => {
    setIdealMatchDescription(user?.matchPreference?.idealMatchDescription);
  }, [isUserLoading]);

  const getprofileData = () => {
    const payload = { username: user?.username };
    getUser(payload);
  };

  const handleSubmit = () => {
    const payload = {
      username: user?.username,
      data: {
        matchPreference: {
          ...user?.matchPreference,
          idealMatchDescription,
          idealMatchDescriptionStatus: "approved",
        },
      },
    };
    updateUser(payload, () => {
      getprofileData();
    });
  };

  return (
    <>
      <TabHeading
        image={images.editProfileDescription}
        title="Ideal Match Description"
        subtitle="Tell us a little about your preferences."
      />
      <div className="edit-profile-content">
        {isUserLoading ? (
          <Loader />
        ) : (
          <>
            {/* Describe you ideal match */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Describe you ideal match" />
              {user?.matchPreference?.idealMatchDescriptionStatus ===
              "approved" ? (
                <ApprovedButton />
              ) : user?.matchPreference?.idealMatchDescriptionStatus ===
                "pending" ? (
                <PendingButton />
              ) : user?.matchPreference?.idealMatchDescriptionStatus ===
                "rejected" ? (
                <RejectedButton />
              ) : null}
            </div>
            <Spacer height="8px" />
            <div className="edit-profile-input match-padding">
              <TextArea
                style={{
                  width: "100%",
                  outline: "none",
                  background: "transparent",
                }}
                showCount
                maxLength={1000}
                rows="10"
                onChange={(e) => setIdealMatchDescription(e.target.value)}
                placeholder="Describe you ideal match"
                value={idealMatchDescription || undefined}
              />
            </div>
            <Spacer height="8px" />
          </>
        )}
        <Spacer height="32px" />
        <PrimaryButton
          text="Save"
          onClick={handleSubmit}
          disabled={isUserLoading}
        />
      </div>
    </>
  );
};

export default Description;








